import { render, staticRenderFns } from "./SupportPopup.vue?vue&type=template&id=76602e1b&scoped=true&"
import script from "./SupportPopup.vue?vue&type=script&lang=js&"
export * from "./SupportPopup.vue?vue&type=script&lang=js&"
import style0 from "./SupportPopup.vue?vue&type=style&index=0&id=76602e1b&lang=postcss&scoped=true&"
import style1 from "./SupportPopup.vue?vue&type=style&index=1&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76602e1b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/unitech/keymetrics/pm2-io/keymetrics/pm2-io-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76602e1b')) {
      api.createRecord('76602e1b', component.options)
    } else {
      api.reload('76602e1b', component.options)
    }
    module.hot.accept("./SupportPopup.vue?vue&type=template&id=76602e1b&scoped=true&", function () {
      api.rerender('76602e1b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/App/SupportPopup.vue"
export default component.exports